import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/config/supabase'

export interface PontosExtrato {
    id: string
    pontos: number
    descricao: string
    tipo: string
    created_at: string
}

export function usePontosExtrato(associado_id: string | null) {
    return useQuery({
        queryKey: ['pontos_extrato', associado_id],
        queryFn: async () => {
            if (!associado_id) return []
            const { data, error } = await supabase
                .schema('veicular_system')
                .from('veic_pontos_extrato')
                .select('*')
                .eq('associado_id', associado_id)
                .order('created_at', { ascending: false })
            
            if (error) throw error
            return data as PontosExtrato[]
        },
        enabled: !!associado_id,
        staleTime: 60_000,
    })
}
